// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".status-select{display:flex}.status-select__full-name{flex:0 1 auto;padding-left:5px;margin-right:15px}", ""]);
// Exports
module.exports = exports;
